
import { defineComponent } from 'vue'
import Circle from '@/components/icons/Circle.vue'

export default defineComponent({
    components: {
        Circle
    },
    props: {
        list: {
            type: Array,
            default: () => {[true]}
        }
    },
}) 
